import { loadFromLocalStorage, saveToLocalStorage } from '@databases/localStorage';
import * as React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { contantAuthentication } from '@contants/index';
import { showError } from '@components/notification';

// Context.
import { AuthContext } from './Authcontext';

// Service.
import { signIn, resetPassword, Registered, getToken } from '@page/Auth/requests';
import { getMe } from '@utils/urls';

const AuthProvider = (props) => {
  const { children } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const [isLogin, setIsLogin] = React.useState(false);

  const [token, setToken] = React.useState(loadFromLocalStorage(contantAuthentication.DATA_AUTH));

  React.useEffect(() => {
    if (isLogin) {
      const origin = location.state?.from?.pathname || '/dashboard';
      const search = location.state?.from?.search || '';
      navigate(`${origin}${search}`);
    }
  }, [isLogin]);

  const handleLogin = async (username, password) => {
    const response = await signIn(username, password);
    if (response?.data?.status === 200) {
      const res = await getToken(response?.data?.data?.user?.api_key);
      const User = JSON.stringify(res?.data.data);
      setToken(User);
      saveToLocalStorage(contantAuthentication.DATA_AUTH, User);
      setTimeout(() => {
        setIsLogin(true);
        navigate('/dashboard');
      });
    } else {
      showError(response?.data.status.message);
    }
  };

  const handleLogout = async () => {
    // Call after Logout Success.
    // const response = await signOut();
    // if (response.status === 200) {
    setToken('');
    saveToLocalStorage(contantAuthentication.DATA_AUTH, '');
    setIsLogin(false);
    navigate('/account/signin');
    // }
  };

  const handleResetPassword = async () => {
    setToken('');
    saveToLocalStorage(contantAuthentication.DATA_AUTH, '');
    setIsLogin(false);
    navigate('/account/signin');
  };

  const handleRegister = async (values) => {
    console.log(values);
    // Call after Logout Success.
    // const response = await Registered();
    // if (response.status === 200) {
    setToken('');
    saveToLocalStorage(contantAuthentication.DATA_AUTH, '');
    setIsLogin(false);
    navigate('/account/signin');
    // }
  };

  const value = {
    token,
    onLogin: handleLogin,
    onLogout: handleLogout,
    resetPassword: handleResetPassword,
    register: handleRegister
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
